<script>
// 名人(旧)
const getNamesUrl = "https://names.library.sh.cn/es/mrPerson/multsearch";

// 名人(新)
const personSearchUrl = 'https://names.library.sh.cn/es/dhc/person/search';

// 照片
const getPhotoUrl = "https://ldy.library.sh.cn/photo/getPhotoList";

// 事件
const getEventUrl = "https://names.library.sh.cn/es/event/search";
// const getEventUrl = "https://data.library.sh.cn/webapi/hsly/route/getEventList";

// 家谱
const getJpUrl = "https://dhapi.library.sh.cn/es/jp/webapi/work/multsearch";

// 古籍
const getGjUrl = "https://gj.library.sh.cn/es/api/gjmult/dhc";
// const getGjUrl = "https://gj.library.sh.cn/es/api/gjmult/inst";

// 盛档
const getSdUrl = "https://names.library.sh.cn/es/sdWork/multsearch";
// const getSdUrl = "https://sd.library.sh.cn/sd/service/search/adv";

// const getVideoUrl       = "https://ldy.library.sh.cn/video/getVideoList";
// const getDynastyUrl     = "https://names.library.sh.cn/mrgf/service/dynasty/all";

// 报刊（报）
const getNewspaperUrl = "https://ldy.library.sh.cn/gateway/api/ssf/feign/bksy/newspaper/listpage/1/";
// const getNewspaperUrl = "https://ldy.library.sh.cn/gateway/api/ssf/feign/bksy/article/listpage/1/10";
// 报刊（刊）
const getMagazineUrl = "https://ldy.library.sh.cn/gateway/api/ssf/feign/bksy/magazine/listpage/1/";

// 红色文献
const getHswxUrl = "https://gj.library.sh.cn/es/instance/multsearch";

// 所有文献接口
const docAllSearchUrl = 'https://names.library.sh.cn/es/dhc/doc/search/';

// 文献模块拖拽顺序存储
const settingHandleUrl = 'https://dhc.library.sh.cn/uc/api/setting/SettingHandle';

// 文献模块拖拽历史查询
const searchSettingUrl = 'https://dhc.library.sh.cn/uc/api/setting/SearchSetting';

// 可视化页面接口（人物）
const getMrPersonVisualizationUrl = 'https://names.library.sh.cn/es/dhc/person/visualization';
// const getMrPersonVisualizationUrl = 'https://names.library.sh.cn/es/mrPerson/visualization';

// 可视化页面接口（文献）
const getDocVisualizationUrl = 'https://names.library.sh.cn/es/dhc/doc/visualization';
// const getDocVisualizationUrl = 'https://gj.library.sh.cn/es/dhc/doc/visualization';

// 可视化页面接口（事件）
const getEventVisualizationUrl = 'https://names.library.sh.cn/es/event/visualization';

// 专业检索url
const getDhcCheckexpUrl = 'https://names.library.sh.cn/es/api/dhc/checkexp';

// 电影片段
const dyHomeVideoListUrl = "https://ldy.library.sh.cn/video/getHomeVideoList";

// 首页电影海报url
const getHomeFilmBillListUrl = "https://ldy.library.sh.cn/movie/getHomeFilmBillList";

// 首页电影人物照片url
const getPersonImageListUrl = "https://ldy.library.sh.cn/person/getPersonImageList";

// 首页电影视频轮播url
const getHomeVideoListUrl = "https://ldy.library.sh.cn/video/getHomeVideoList";

// 注册
const registerUrl = 'https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/register?systemId=15&redirectUrl=https://dhc.library.sh.cn';

// 登录
const authorizeUrl = 'https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/locpage?';

// 退出
const logoutUrl = 'https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/logout';

// 获取用户信息url
const getAccountUrl = 'https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/account';

// 存储/获取 检索参数
const dhcLogUri = "https://names.library.sh.cn/es/dhc/log";

// 用户信息
var userInfo = null;

// 首页描述
var description = '截止到2023年5月，已整合近代报纸510余种、篇目140760余种、广告44210余条、图片20张；期刊8种、篇目30余种、图片16张；近代图书124400余种；家谱71820余种；古籍602450余种；盛档15万余件；红色文献8500余种。以及1332440余人物和7480余事件。';

// 家谱描述
const jpDescription = "家谱知识服务平台对中国家谱总目和馆藏家谱目录及内容进行重组、丰富和格式转换，展示了包括全球597家馆藏家谱的书目数据，开放上图馆藏家谱部分全文影像、家规家训全文浏览和检索、部分名人世系表，支持简单检索、高级检索、地图检索多种检索方式，并对搜索结果提供、人、地、时、事多维分面浏览服务，人物关系可视化、时空关系可视化等数据可视化服务与数据统计分析服务，提供在线识谱、在线修谱、上传家谱等功能，鼓励公众参与知识创新。";

// 古籍描述
const gjDescription = "中文古籍联合目录及循证平台致力于实现基于互联网的、全球范围内的中文古籍书目控制，在线展示上海图书馆、加州柏克莱大学东亚图书馆、澳门大学图书馆、哈佛燕京图书馆、美国哥伦比亚大学东亚馆的部分古籍善本扫描影像全文，融合历史上具有一定影响的官修目录、史志目录、藏书楼目录、私家目录和版本目录等，辅之以人名、地名、印章、避讳字、刻工等额外规范数据，实现各馆现存古籍珍藏的联合查询、规范控制，并提供学者循证版本、考镜流藏之功用。";

// 盛档描述
const sdDescription = "盛宣怀档案知识库重组了盛宣怀家族自1850年至1936年期间记录的信札、电报、合同、日记等15万余件档案的目录数据，内容涉及政治、经济、社会、军事、外交、金融、贸易、教育各方面。平台提供“关系”、“时空”、“人物”、“公司” 四个维度探索档案资源，加入了专业人士对盛宣怀档案精华部分的解说批注，丰富了涉及到的2万8千余人的信函电报往来关系图，利用时空分析法、社会关系分析法和可交互的可视化技术展示大规模档案资源。";

// 红色文献描述
const hswxDescription = "革命（红色）文献知识服务平台，收录上海图书馆馆藏的8500多种革命书目，利用数字人文及相关技术对馆藏数据进行重新组织，把不同类型的文献资源集中在平台上为大众服务；推出“红色旅游”专题网站活用红色文献，收录上海377个红色景点，与上图红色文献知识库及相关基础知识库进行关联、整合，全方位展示红色景点的历史变迁和文化风貌，支持用户用手机访问，用户可以根据推荐的旅游路线实地走读，也可以方便地自定义心仪的旅游线路。";

// 报刊（报）描述
const bkDescription = "依托上海图书馆珍贵馆藏资源，将近代出版的各类报纸悉数囊括，社情百态、一库尽揽，为专业、全面地展示近代历史，提供了完整的史料依据。大报视野广阔、报道及时、内容丰富，对海内外重要事件均有涉及，且各大报之间可互相印证，方便广大读者和研究人员进行比较研究。除了大报名报，全库也收录将近千份的小报以及形式、内容各异的各类近代报纸。这些报纸“能纪大报所不能纪，能言大报所不能言”，为历史研究提供了独特的视角。";

// 报刊（刊）描述
const bkMagDescription = "收录近代出版的两万余种期刊，近一千万篇文献，内容集中反映这一时期的政治、军事、外交、经济、教育、思想文化、宗教等各方面的情况。作为历史档案的重要组成部分，该库具有极为重要的学术价值和史料价值，方便广大读者用户进行关于近代历史的学术研究。此外，该库精选了近三百种文学类期刊，共计六十六万余页，进行全文本识别，为广大读者和研究人员深入挖掘内容、提高研究效率奠定了坚实的基础。";

// 近代图书描述
const jdtsDescription = "近代图书作为一种媒体，蕴含着思想、承载着知识，紧贴时代发展的脉动，是展示近代历史风云，研究近代历史不可或缺的重要文献。该库依托上海图书馆馆藏数量可观的珍贵近代图书资源，数量达12万余种，其中不乏独有的珍稀馆藏，极具史料价值和学术研究意义。同时经过数字人文团队精心打磨，将近代图书和相关的人、地、时、事等基础知识库进行关联，实现地图检索、版本聚类等特色功能。";

// 名人描述
const namesDescription = "人名规范库基于互联网提供人名规范控制服务，数据主要来源于家谱、盛档、古籍等文献知识库中的责任者或其他少量与文献资源相关的重要人物，并以网络百科、人名辞典以及CBDB等开放数据集作为人物个人信息的补充，利用HTTP URI唯一地标识一个人物实体，搜集人物的各种异名，基于HTTP URI建立人物和所有相关文献、地名、时间之间的关联，揭示人物之间的关系，提供人物的生卒年、籍贯、生平大事、个人小传、任职经历、社会关系等开放数据服务。";

// 事件描述
const eventDescription = "“上海历史文化年谱”以时间为线索，收录了近代上海开埠至新中国建立期间，新闻出版、戏剧、戏曲、电影、音乐、舞蹈、美术、建筑、宗教、教育、文物博物馆、图书馆等文化领域内重要事件、人物、机构、出版物的相关信息。按照资源的重要性和资源情况，分为大、中、小条目，希望籍此能将上海图书馆历年来开发完成的历史文献专题资源库、专题库整合起来，成为一个综合性资源总库，为读者提供较为完整、系统的检索和浏览。";

// 首页电影页面描述
const homeDyDescription = "电影库包含了电影元数据2157部，影人897人，影戏院10家，电影期刊400种、篇目84099篇，电影老照片1730张，电影音频44段，电影视频154段等重要数据";

// 检索埋点
const createUserLog = 'https://dhc.library.sh.cn/uc/api/userLog/CreateUserLog';

// 添加收藏
const createCollect = 'https://dhc.library.sh.cn/uc/api/favorites/CreateCollect';

// 取消收藏
const collectHandle = 'https://dhc.library.sh.cn/uc/api/favorites/CollectHandle';

// 查询收藏
const searchCollectCode = 'https://dhc.library.sh.cn/uc/api/favorites/SearchCollectCode';

// 查询收藏夹
const searchFavorites = 'https://dhc.library.sh.cn/uc/api/favorites/SearchFavorites';

// 创建收藏夹
const createFavorites = 'https://dhc.library.sh.cn/uc/api/favorites/CreateFavorites';

// 浏览历史和下载历史
const favoritesCreateResource = 'https://dhc.library.sh.cn/uc/api/favorites/CreateResource';

export default {
    getNamesUrl,        // 名人(旧)
    personSearchUrl,    // 名人(新)
    getEventUrl,        // 事件
    getPhotoUrl,        // 照片
    getJpUrl,           // 家谱
    getGjUrl,           // 古籍
    getSdUrl,           // 盛档
    getNewspaperUrl,    // 报刊（报）
    getMagazineUrl,     // 报刊（刊）
    getHswxUrl,         // 红色文献
    docAllSearchUrl,    // 所有文献统一接口
    settingHandleUrl,   // 文献模块拖拽顺序存储
    searchSettingUrl,   // 文献模块拖拽历史查询
    getMrPersonVisualizationUrl, // 可视化页面接口（人物）
    getDocVisualizationUrl,      // 可视化页面接口（文献）
    getEventVisualizationUrl,    // 可视化页面接口（事件）
    getDhcCheckexpUrl,      // 专业检索url
    dyHomeVideoListUrl,     // 电影片段
    getHomeFilmBillListUrl, // 首页电影海报url
    getPersonImageListUrl,  // 首页电影人物照片url
    getHomeVideoListUrl,    // 首页电影视频轮播url
    registerUrl,        // 注册
    authorizeUrl,       // 登录
    logoutUrl,          // 退出登录
    getAccountUrl,      // 获取用户信息
    dhcLogUri,          // 存储参数
    userInfo,           // 用户信息
    description,        // 首页描述
    jpDescription,      // 家谱描述
    gjDescription,      // 古籍描述
    sdDescription,      // 盛档描述
    hswxDescription,    // 红色文献描述
    bkDescription,      // 报刊（报）描述
    bkMagDescription,   // 报刊（刊）描述
    jdtsDescription,    // 近代图书描述
    namesDescription,   // 名人描述
    eventDescription,   // 事件描述
    homeDyDescription,  // 首页电影页面描述
    createUserLog,      // 检索埋点
    createCollect,      // 添加收藏
    collectHandle,      // 取消收藏
    searchCollectCode,  // 查询收藏
    searchFavorites,    // 查询收藏夹
    createFavorites,    // 创建收藏夹
    favoritesCreateResource, // 浏览历史和下载历史
}
</script>